"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferEligibilityAutoCheckStatus = void 0;
var OfferEligibilityAutoCheckStatus;
(function (OfferEligibilityAutoCheckStatus) {
    OfferEligibilityAutoCheckStatus["pending"] = "pending";
    OfferEligibilityAutoCheckStatus["processing"] = "processing";
    OfferEligibilityAutoCheckStatus["completed"] = "completed";
    OfferEligibilityAutoCheckStatus["failed"] = "failed";
})(OfferEligibilityAutoCheckStatus || (exports.OfferEligibilityAutoCheckStatus = OfferEligibilityAutoCheckStatus = {}));
